export default Object.freeze({
  PENDING: 'PENDING',
  PROCESSING: 'PROCESSING',
  PAYED: 'PAYED',
});
